export enum ApplicationSettingType {
    none = 0,
    header ,
    footer 
}